import { IdResource } from "../../../../constants/IdResource";
export var checkIsResourceMoney = function (path) { return function (action, state$, dependencies) {
    return action.resourceId === IdResource.Money ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/inventory/checks/checkIsResourceMoney.ts
// module id = 1906
// module chunks = 3